import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/views/HomePage.vue'),
  },
    {
      path: '/HomePage',
      name: 'HomePage',
      component: () => import('@/views/HomePage.vue'),
      children:[
        {
          path:'/HomePage/home',
          name: 'home',
          component: () => import('@/views/home.vue'),
          meta:{
            title:"浙江省征地信息公开平台"
          }
        },
        {
          path:'/HomePage/zcfg',
          name: 'zcfg',
          component: () => import('@/views/zcfg.vue')
        },
        {
          path:'/HomePage/zcfgDetail',
          name: 'zcfgDetail',
          component: () => import('@/views/zcfgDetail.vue')
        },
        {
          path:'/HomePage/zdxm',
          name: 'zdxm',
          props: (route) => ({ ...route.query, ...route.params }),//可以运用props结合扩展运算符获取参数
          component: () => import('@/views/zdxm.vue')
        },
        
        {
          path:'/HomePage/zdxmDetail',
          name: 'zdxmDetail',
          props: (route) => ({ ...route.query, ...route.params }),//可以运用props结合扩展运算符获取参数
          component: () => import('@/views/zdxmDetail.vue')
        },
        {
          path:'/HomePage/phss',
          name: 'phss',
          component: () => import('@/views/phss.vue')
        },
        {
          path:'/HomePage/phssDetail',
          name: 'phssDetail',
          component: () => import('@/views/phssDetail.vue')
        },
        {
          path:'/HomePage/pqss',
          name: 'pqss',
          component: () => import('@/views/pqss.vue')
        },
        {
          path:'/HomePage/pqssDetail',
          name: 'pqssDetail',
          component: () => import('@/views/pqssDetail.vue')
        },
        {
          path:'/HomePage/pfwj',
          name: 'pfwj',
          component: () => import('@/views/pfwj.vue')
        },
        {
          path:'/HomePage/pfwjDetail',
          name: 'pfwjDetail',
          component: () => import('@/views/pfwjDetail.vue')
        },
        {
          path:'/HomePage/dlhz',
          name: 'dlhz',
          component: () => import('@/views/dlhz.vue')
        },
        {
          path:'/HomePage/dlhzDetail',
          name: 'dlhzDetail',
          component: () => import('@/views/dlhzDetail.vue')
        },
        {
          path:'/HomePage/ysssfa',
          name: 'ysssfa',
          component: () => import('@/views/ysssfa.vue')
        },
        {
          path:'/HomePage/ysssfaDetail',
          name: 'ysssfaDetail',
          component: () => import('@/views/ysssfaDetail.vue')
        },

        {
          path:'/HomePage/Fjyl',
          name: 'Fjyl',
          component: () => import('@/views/Fjyl.vue')
        },


      ]
    },
    {
      path: '/openscreen',
      name: 'openscreen',
      component: () => import('@/views/outerpage/openscreen.vue'),
    },
  ]

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});


router.beforeEach((to, from, next) => {
  // console.log(to,from,next)
  // if(to.name == "zdxm" || to.name == "zdxmDetail"){
  //   next();
  // }else{
  //   if(to.name != 'home' || to.name != 'HomePage' ){
  //     next();
  //   }else{
  //     next();
  //   }
  // }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if(localStorage.getItem("isOLD") == "true"){
    document.body.classList.add("isOLD");
  }else{
    document.body.classList.remove("isOLD");
  }
  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js